import { render, staticRenderFns } from "./SurveyDetailHeader.vue?vue&type=template&id=7b65c3e3"
import script from "./SurveyDetailHeader.ts?vue&type=script&lang=ts&external"
export * from "./SurveyDetailHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports